import { render, staticRenderFns } from "./integralRecord.vue?vue&type=template&id=f21f1628&scoped=true"
import script from "./integralRecord.vue?vue&type=script&lang=js"
export * from "./integralRecord.vue?vue&type=script&lang=js"
import style0 from "./integralRecord.vue?vue&type=style&index=0&id=f21f1628&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21f1628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f21f1628')) {
      api.createRecord('f21f1628', component.options)
    } else {
      api.reload('f21f1628', component.options)
    }
    module.hot.accept("./integralRecord.vue?vue&type=template&id=f21f1628&scoped=true", function () {
      api.rerender('f21f1628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/components/integralRecord.vue"
export default component.exports